import { BREAKPOINTS } from "configs/constants";
import { CfOpenBannerProps } from "components/OpenBanner/CfOpenBanner/schema";
import { convertCfImageProps } from "components/Image/CfImage";
import Image from "components/Image";
import OpenBanner from "components/OpenBanner";
import React from "react";
import recursiveRender from "utilities/recursiveRender";

const convertCfOpenBannerProps = ({
  topEditorial,
  ctaListCustom,
  bottomEditorial,
  backgroundTheme,
  bannerImage,
  internalWrapper,
  tagGroup,
  isMain,
}: CfOpenBannerProps) => ({
  topEditorial: topEditorial && recursiveRender({ cfComponent: topEditorial }),
  ctaList: ctaListCustom && recursiveRender({ cfComponent: ctaListCustom }),
  bottomEditorial:
    bottomEditorial && recursiveRender({ cfComponent: bottomEditorial }),
  backgroundTheme,
  bannerImage: bannerImage && (
    <Image
      {...convertCfImageProps({ ...bannerImage, breakpoint: BREAKPOINTS.md })}
      objectFit="contain"
      customClass="open-banner__image"
    />
  ),
  internalWrapper,
  tagGroup: tagGroup && recursiveRender({ cfComponent: tagGroup }),
  isMain,
});

const CfOpenBanner = (props: CfOpenBannerProps) => (
  <OpenBanner {...convertCfOpenBannerProps(props)} />
);

export default CfOpenBanner;
